/** Lifetime admission, not a rate limit: an offline SDK queue cannot grow forever. */
export class BrowserCloudBudget {
  private activity = 0;
  private exceptions = 0;
  private reported = new Set<string>();
  constructor(private readonly onExhausted: (kind: 'activity' | 'exception') => void = () => undefined) {}
  admit(exception: boolean): boolean {
    const kind = exception ? 'exception' : 'activity';
    const used = exception ? this.exceptions : this.activity;
    const limit = exception ? 50 : 450;
    if (used >= limit) {
      if (!this.reported.has(kind)) { this.reported.add(kind); try { this.onExhausted(kind); } catch { /* Local-only warning. */ } }
      return false;
    }
    if (exception) this.exceptions++; else this.activity++;
    return true;
  }
}
